package org.hs_soft.runmynesto.domain.model.home.template.product_categories

import kotlinx.serialization.Serializable

@Serializable
data class TemplateCategoryData(
    val data: Data?=null,
)